export const cssBundleHref = "/build/css-bundle-S73UZXZG.css";